// Garde-fou de route : renvoie vers /login si personne n'est connecte.
//
// Ce n'est qu'un confort d'affichage. La vraie protection est cote
// serveur : chaque endpoint verifie le token et l'abonnement. Masquer
// un ecran dans le navigateur ne protege rien en soi.
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../lib/AuthContext'

export default function RequireAuth ({ children }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="bootstrap">Chargement…</div>
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />

  return children
}
